/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdWebFeaturesInfoNewsNewsL10nMessageFromJSON, FxIdWebFeaturesInfoNewsNewsL10nMessageToJSON, } from './FxIdWebFeaturesInfoNewsNewsL10nMessage';
import { FxIdDomainEntitiesNewsPriorityFromJSON, FxIdDomainEntitiesNewsPriorityToJSON, } from './FxIdDomainEntitiesNewsPriority';
/**
 * Check if a given object implements the FxIdWebFeaturesInfoNewsNews interface.
 */
export function instanceOfFxIdWebFeaturesInfoNewsNews(value) {
    if (!('Id' in value) || value['Id'] === undefined)
        return false;
    if (!('CreatedAt' in value) || value['CreatedAt'] === undefined)
        return false;
    if (!('Messages' in value) || value['Messages'] === undefined)
        return false;
    if (!('Priority' in value) || value['Priority'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesInfoNewsNewsFromJSON(json) {
    return FxIdWebFeaturesInfoNewsNewsFromJSONTyped(json, false);
}
export function FxIdWebFeaturesInfoNewsNewsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Id': json['Id'],
        'CreatedAt': (new Date(json['CreatedAt'])),
        'Messages': (json['Messages'].map(FxIdWebFeaturesInfoNewsNewsL10nMessageFromJSON)),
        'Priority': FxIdDomainEntitiesNewsPriorityFromJSON(json['Priority']),
        'Link': json['Link'] == null ? undefined : json['Link'],
        'IconUrl': json['IconUrl'] == null ? undefined : json['IconUrl'],
        'ImageUrl': json['ImageUrl'] == null ? undefined : json['ImageUrl'],
        'Tags': json['Tags'] == null ? undefined : json['Tags'],
    };
}
export function FxIdWebFeaturesInfoNewsNewsToJSON(json) {
    return FxIdWebFeaturesInfoNewsNewsToJSONTyped(json, false);
}
export function FxIdWebFeaturesInfoNewsNewsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Id': value['Id'],
        'CreatedAt': ((value['CreatedAt']).toISOString()),
        'Messages': (value['Messages'].map(FxIdWebFeaturesInfoNewsNewsL10nMessageToJSON)),
        'Priority': FxIdDomainEntitiesNewsPriorityToJSON(value['Priority']),
        'Link': value['Link'],
        'IconUrl': value['IconUrl'],
        'ImageUrl': value['ImageUrl'],
        'Tags': value['Tags'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesInfoNewsNews.js.map